import * as types from './types';
import { loading, success, error } from 'State/actions';

export const getServerTime = () => async (dispatch, getState, MPWWebAPI) => {
  dispatch(loading(types.GET_SERVER_TIME_FETCHING, true));
  dispatch(error(types.GET_SERVER_TIME_FETCH_ERROR, null));
  try {
    const response = await MPWWebAPI.getGeneric('Zones/GetServerTime');
    const serverTime = response.data.Data;
    dispatch(success(types.GET_SERVER_TIME_FETCH, serverTime));
  } catch (err) {
    dispatch(error(types.GET_SERVER_TIME_FETCH_ERROR, err));
  }
  dispatch(loading(types.GET_SERVER_TIME_FETCHING, false));
};



// WEBPACK FOOTER //
// ./src/state/serverTime/actions.js